
export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-zinc-400 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">THOMAS</h3>
            <p className="text-sm leading-relaxed">
              Bringing mind-bending mentalism and interactive entertainment to college campuses nationwide. Creating unforgettable experiences for student life, orientation events, and campus festivals.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="hover:text-red-600 transition-colors duration-300 cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="/#about" className="hover:text-red-600 transition-colors duration-300 cursor-pointer">
                  About Thomas
                </a>
              </li>
              <li>
                <a href="/corporate" className="hover:text-red-600 transition-colors duration-300 cursor-pointer">
                  Corporate Events
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-red-600 transition-colors duration-300 cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold mb-4">Connect</h4>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-zinc-800 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-zinc-800 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Thomas Mentalism. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
